import { Card, CardContent, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { authProvider } from '../../services/Security';
import { StatsService } from '../../services/StatsService';

const IrisByType = () => {
    const [stats, setStats] = useState<any>();
    const [operatorId, setOperatorId] = useState<any>();
    const [type, setType] = useState<any>();
    
    useEffect(() => {
        window.addEventListener('message', event => {
            // IMPORTANT: check the origin of the data!
            if(!event.data) return;
            var data = JSON.parse(event?.data);
            authProvider.setToken(data?.token)
            setOperatorId(data?.operatorId)
            setType(data.type);
            if(data.type.toLowerCase() === 'email'){
                StatsService.statsVGetEmailsCount(data?.operatorId, data?.districtId)
                    .then(x => setStats(x))
                    .catch(x => console.log(x))
            } else {
                StatsService.statsVGetSMSCount(data?.operatorId, data?.districtId)
                    .then(x => setStats(x))
                    .catch(x => console.log(x))
    
            }
            // setToken(data?.token)
            // if (event.origin === 'https://your-first-site.example') {
            //     // The data was sent from your site.
            //     // Data sent with postMessage is stored in event.data:
            // } else {
            //     // The data was NOT sent from your site!
            //     // Be careful! Do not use it. This else branch is
            //     // here just for clarity, you usually shouldn't need it.
            //     return;
            // }
        });
    }, [])

    return (
        <Card raised={false} style={{width: "100%"}}>
            <CardContent>
                <Typography variant="h5" component="h2" style={{textAlign:"center"}}>{type} This Month</Typography>
                {operatorId ?
                    <>
                        <div>
                            Total: {stats?.totalThisMonth}
                        </div>
                        <div>
                            Other: {stats?.otherThisMonth}
                        </div>
                        <div>
                            Payment Confirmation: {stats?.paymentConfirmationThisMonth}
                        </div>
                        <div>
                            Forgot Username: {stats?.forgotUsernameThisMonth}
                        </div>
                        <div>
                            Password Reset: {stats?.passwordResetThisMonth}
                        </div>
                        <div>
                            Password Reset Confirmation: {stats?.passwordResetConfirmationThisMonth}
                        </div>
                        <div>
                            Bill Ready: {stats?.onlineBillReadyThisMonth}
                        </div>
                        <div>
                            Paperless Added: {stats?.paperlessAddedThisMonth}
                        </div>
                        <div>
                            Paperless Removed: {stats?.paperlessRemovedThisMonth}
                        </div>
                        <div>
                            Recurring Added: {stats?.recurringAddedThisMonth}
                        </div>
                        <div>
                            Recurring Removed: {stats?.recurringRemovedThisMonth}
                        </div>
                        <div>
                            Payment Failure: {stats?.paymentFailureThisMonth}
                        </div>
                    </> :
                    <div>No Operator Selected</div>
                }
                <Typography variant="h5" component="h2" style={{textAlign:"center"}}>{type} Last Month</Typography>
                {operatorId ?
                    <>
                        <div>
                            Total: {stats?.totalLastMonth}
                        </div>
                        <div>
                            Other: {stats?.otherLastMonth}
                        </div>
                        <div>
                            Payment Confirmation: {stats?.paymentConfirmationLastMonth}
                        </div>
                        <div>
                            Forgot Username: {stats?.forgotUsernameLastMonth}
                        </div>
                        <div>
                            Password Reset: {stats?.passwordResetLastMonth}
                        </div>
                        <div>
                            Password Reset Confirmation: {stats?.passwordResetConfirmationLastMonth}
                        </div>
                        <div>
                            Bill Ready: {stats?.onlineBillReadyLastMonth}
                        </div>
                        <div>
                            Paperless Added: {stats?.paperlessAddedLastMonth}
                        </div>
                        <div>
                            Paperless Removed: {stats?.paperlessRemovedLastMonth}
                        </div>
                        <div>
                            Recurring Added: {stats?.recurringAddedLastMonth}
                        </div>
                        <div>
                            Recurring Removed: {stats?.recurringRemovedLastMonth}
                        </div>
                        <div>
                            Payment Failure: {stats?.paymentFailureLastMonth}
                        </div>
                    </> :
                    <div>No Operator Selected</div>
                }
            </CardContent>
        </Card>
    );
}

export default IrisByType;
  